import React, { useState, useEffect } from "react"
import _ from "lodash"
import keyService, * as chord from "data/key"
import { Colors } from "styles/app-styles"

// cell focus
const cellFocusStyle = `outline: 2px solid ${Colors.blackPearl}; outline-offset: -1px;`
const cellNoFocusStyle = ""

const findNestedInput = (node) => {
  if(node.tagName === "INPUT") return node
  else {
    for(let i = 0; i < node.children.length; i++) {
      let childNode = node.children[i]
      if(childNode.tagName === "INPUT") return childNode
      else return findNestedInput(childNode)
    }
  }
}

const findParentDropdownEditable = (ele) => {
  if(ele) {
    if(Array.from(ele.classList).includes("automated")) return ele
    else return findParentDropdownEditable(ele.parentElement)
  } else return null
}

type IConfirmationAutomation = {
  activeTab?: number,
  cancel?: Function,
  outsideTable?: boolean
}

const ConfirmationAutomation = (props: IConfirmationAutomation) => {
  const [focusIndex, setFocusIndex] = useState<number>(0)

  useEffect(() => {
    const overrideKeyHandlers = e => {
      if(_.includes(["Tab"], e.key)) {
        e.preventDefault()
        return false
      }
    }

    const focusCell = (node) => {
      if(node && (_.includes(node.className, "p-dropdown") || _.includes(node.className, "p-checkbox"))) {
        const dd = findNestedInput(node)
        if(dd) {
          dd.focus()
          node.style.cssText += cellFocusStyle
        }
      } else if(node && _.includes(node.className, "p-editable-column")) {
        node.style.cssText += cellFocusStyle
        node.click()
      } else if (node) {
        node.style.cssText += cellFocusStyle
        node.focus()
      } else return
    }

    // focus first node on load
    const firstNode = document.getElementsByClassName("automated")[0] as HTMLInputElement
    if(firstNode && focusIndex === 0) {
      focusCell(firstNode);
    }

    const getEditableNodes = () => {
      const primaryNodes = Array.from(document.getElementsByClassName("automated"))
      const secondaryNodes = Array.from(document.getElementsByClassName("automated-secondary"))
      let editableNodes = primaryNodes.concat(secondaryNodes)
      editableNodes =
        _.filter(editableNodes, node => node.nodeName !== "TH" &&
        !(_.includes(node.className, "p-component") && _.includes(node.parentElement.className, "p-cell-editing")) &&
        !_.includes(node.className, "p-disabled"))
      return editableNodes
    }

    const unfocusPrevious = (nodes) => {
      if(nodes[focusIndex] && (_.includes(nodes[focusIndex].className, "p-dropdown") || _.includes(nodes[focusIndex].className, "p-checkbox"))) {
        const dd = findNestedInput(nodes[focusIndex])
        _.invoke(dd, "blur")
      } else {
        //_.invoke(nodes[focusIndex], "blur")
        // this was breaking dropdowns, and doesnt seem to do anything here, must be leftover from table implementation
      }
      if(nodes[focusIndex]) nodes[focusIndex].setAttribute("style", cellNoFocusStyle)
    }

    const updateFocus = (nodes, newIndex) => {
      const node = nodes[newIndex]
      unfocusPrevious(nodes)
      focusCell(node)
      setFocusIndex(newIndex)
    }

    const keySubscription = keyService.stream().subscribe(k => {
      const editableNodes = getEditableNodes()
      let newIndex = 0

      switch(true) {
        case k.chord === chord.TAB && k.down === true:
          newIndex = focusIndex + 1
          if(newIndex < editableNodes.length) {
            updateFocus(editableNodes, newIndex)
          }
          break
        case k.chord === chord.SHIFT_TAB && k.down === true:
          newIndex = focusIndex - 1
          if(newIndex >= 0) {
            updateFocus(editableNodes, newIndex)
          }
          break
        case k.chord === chord.ESC && k.down === true:
          if(props.cancel) props.cancel()
          break
      }
    })

    const clickSync = e => {
      const editableNodes = getEditableNodes()

      let target_rect = e.target.getBoundingClientRect()
      if(e.target && e.target.className && _.isString(e.target.className) && (e.target.className.includes("p-dropdown") || e.target.className.includes('p-checkbox'))){
        const parentDD = findParentDropdownEditable(e.target)
        if(parentDD) target_rect = parentDD.getBoundingClientRect()
      }
      let n_idx = -1
      _.forEach(editableNodes, (n, i) => {
        let n_rect = n.getBoundingClientRect()
        if(-2 <= n_rect.x - target_rect.x &&
            n_rect.x - target_rect.x <= 2 &&
            -2 <= n_rect.y - target_rect.y &&
            n_rect.y - target_rect.y <= 2 &&
            -2 <= n_rect.width - target_rect.width &&
            n_rect.width - target_rect.width <= 2 &&
            -2 <= n_rect.height - target_rect.height &&
            n_rect.height - target_rect.height <= 2)
        {
          n_idx = i
          return false
        }
      })
      if(n_idx >= 0) updateFocus(editableNodes, n_idx)
    }

    document.addEventListener("keydown", overrideKeyHandlers)
    document.addEventListener("select", clickSync)
    document.addEventListener("click", clickSync)

    return function cleanup() {
      keySubscription.unsubscribe()
      document.removeEventListener("keydown", overrideKeyHandlers)
      document.removeEventListener("select", clickSync)
      document.removeEventListener("click", clickSync)
    }
  }, [focusIndex, props.activeTab, props.outsideTable])

  return null
}

export default ConfirmationAutomation
